
import { getCookie } from 'cookies-next';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getFilteredProperties2 = async (filters, email = null, localeValue = 'en') => {
    let currencyValue = getCookie('currency')
    // let localeValue = getCookie('NEXT_LOCALE')
    // console.log(currencyValue)

    const { saleType, bts, project, category, room, minBedrooms, maxBedrooms, page, currency, minprice, maxprice, petfriendly, seaview, beachfront, map, sort, district, location } = filters
    // console.log(filters)
    const url = `${baseUrl}/properties?saleType=${saleType}&bts=${bts}&location=${location}&district=${district}&project=${project}&category=${category}&minprice=${minprice}&maxprice=${maxprice}&room=${room}&petfriendly=${petfriendly}&seaview=${seaview}&beachfront=${beachfront}&map=${map}&page=${page}&sort=${sort}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'email': email,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        cache: 'no-store'
    })

    const result = await response.json()
    console.log(result)

    const id = getCookie('id')
    const likes = getCookie('likes')
    if (id == undefined && likes !== undefined && likes.length > 0 && result.properties.length > 0) {
        console.log('has likes')
        result.properties.forEach(property => {
            if (likes.includes(property.id)) {
                property.isLiked = true
            }
        })
    }

    return result

}